import { css } from '@landr/styled-system/css';

export const ContentContainer = css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingY: 'none',
    paddingX: 'lg',
    marginTop: {
        sm: 0,
    },
});

export const HeaderContainer = css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
});

export const TextContainer = css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    flexDirection: 'column',
});
